import { FC, FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'

import { useCreateOrganizationMutation, useEditOrganizationMutation } from 'services/organizations'

import AvatarUpload from 'components/AvatarUpload'
import Modal from 'components/Modal'
import { TModalVariant } from 'components/Modal/types'

interface Props {
  variant: TModalVariant
  onClose: () => void
  organizationName?: string
}

const OrganizationActionModal: FC<Props> = ({ variant, onClose, organizationName = '' }) => {
  const { t } = useTranslation()
  const [name, setName] = useState(organizationName)
  const { organizationId } = useParams()

  const [create, { isLoading: isCreateLoading }] = useCreateOrganizationMutation()
  const [edit, { isLoading: isEditLoading }] = useEditOrganizationMutation()

  const title =
    variant === 'create'
      ? t('Pages.Organizations.CreateOrganization')
      : t('Pages.Organizations.EditOrganization')

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    console.log(organizationId)
    e.preventDefault()
    if (variant === 'create')
      create({ name })
        .unwrap()
        .then(onClose)
        .catch(() => null)
    else if (organizationId)
      edit({ organizationId, name })
        .unwrap()
        .then(onClose)
        .catch(() => null)
  }

  return (
    <Modal open handleClose={onClose} title={title}>
      <Box display="flex" gap={3} flexDirection="column" component={'form'} onSubmit={handleSubmit}>
        <AvatarUpload />
        <TextField
          label={t('Pages.Organizations.NameOfOrganization')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ minWidth: { xs: '311px', sm: '470px' } }}
        />
        <Box display="grid" gridTemplateColumns={'1fr 1fr'} gap={{ xs: 2, sm: 3 }}>
          <Button variant="outlined" onClick={onClose}>
            {t('Buttons.Cancel')}
          </Button>
          <Button
            variant="contained"
            type="submit"
            disabled={isCreateLoading || isEditLoading || !name.trim()}
          >
            {t('Buttons.Save')}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default OrganizationActionModal
